import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "../../performance/custom.css";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const EmployeePerformanceReview = () => {
  const { id } = useParams();
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const navigate = useNavigate();
  const [showFullText, setShowFullText] = useState(false);
  const [activetab, setActivetab] = useState<any>("kra");
  const [kraDetailsData, setKraDetailsData] = useState<any>([]);
  const [behaDetailsData, setBehaDetailsData] = useState<any>([]);
  const [comaspiDetailsData, setComaspiDetailsData] = useState<any>({
    employee_carrier_aspiration: "",
    manager_carrier_aspiration: "",
  });
  const [kracount, setKraCount] = useState(1);
  const routes = all_routes;
  const tabs = [
    { value: "kra", label: "KRA 80%" },
    { value: "Behavioural Competence", label: "Behavioural Competence" },
    { value: "Career Aspirations", label: "Career Aspirations" },
  ];

  const {
    data: goalSetting,
    error: goalSettingerror,
    loading: goalSettingLoading,
  } = useApi("/api/get-goal-setting-timing", {
    method: "POST",
    autoCall: true,
    payload: {
      financial_year: finance_year,
    },
    dependencies: [finance_year],
  });

  const {
    data: getkradetails,
    loading: kradetailsLoading,
    error: kradetailsError,
  } = useApi("/api/manager/view-employee-kra", {
    method: "POST",
    payload: {
      category_id: id,
    },
    autoCall: true,
    dependencies: [kracount],
  });

  const {
    data: getbehaiviourdetails,
    loading: behaiviourdetailsLoading,
    error: behaiviourdetailsError,
  } = useApi("/api/behavioural-details", {
    method: "GET",
    autoCall: true,
    dependencies: [kracount],
  });

  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/manager/view-comments-aspiration", {
    method: "POST",
    payload: {
      category_id: id,
    },
    autoCall: true,
    dependencies: [kracount],
  });

  useEffect(() => {
    if (getkradetails?.success) setKraDetailsData(getkradetails?.data);
  }, [getkradetails]);

  useEffect(() => {
    if (getbehaiviourdetails?.success) {
      setBehaDetailsData(getbehaiviourdetails?.data);
    }
  }, [getbehaiviourdetails]);

  useEffect(() => {
    if (getcomaspidetails?.sucess) {
      setComaspiDetailsData(getcomaspidetails?.data);
    }
  }, [getcomaspidetails]);
  const getInputdata = (e: any) => {
    const { name, value } = e.target;
    setComaspiDetailsData({ ...comaspiDetailsData, [name]: value });
  };
  const {
    data: addComAspiRatingdetails,
    loading: addComAspiRatingdetailsLoading,
    error: addComAspiRatingdetailsError,
    callApi: AddRaitingComAspi,
  } = useApi("/api/manager/add-comments-aspiration", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmitComAspi = async (
    e: any,
    action: "draft" | "submit",
  ) => {
    e.preventDefault();
    const payload = {
      status: action === "draft" ? "M_DRAFT" : "",
      comments: comaspiDetailsData.employee_comments,
      aspiration: comaspiDetailsData.manager_carrier_aspiration,
      employee_id: comaspiDetailsData?.employee_id,
      category_id: id,
    };
    try {
      const response = await AddRaitingComAspi(payload);
      if (response.sucess) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/pms-employee-goals");
        setKraCount(kracount + 1);
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleBack = () => {
    localStorage.removeItem("GoalsProfileEmployeeID");
    navigate("/pms-employee-goals");
  };

  console.log(comaspiDetailsData);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Performance Review</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Performance Review
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2 d-flex gap-2">
              <button
                className="btn btn-outline-secondary"
                onClick={handleBack}
              >
                ← Back
              </button>
              <CollapseHeader />
            </div>
          </div>
          <section className="custom-card">
            <div className="custom-card-header d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                {tabs.map((item, index) => (
                  <button
                    className={`${
                      activetab === item.value
                        ? "btn btn-primary custom_button"
                        : "btn btn-primary tab-button"
                    }`}
                    onClick={() => {
                      setActivetab(item.value);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
              <div>
                <button
                  className="btn btn-outline-dark"
                  data-bs-toggle="modal"
                  data-bs-target={
                    activetab === "Behavioural Competence"
                      ? "#behaviouralinfo"
                      : "#ratinginfo"
                  }
                >
                  <i className="fa fa-users"></i>
                </button>
              </div>
            </div>

            {activetab === "kra" ? (
              <>
                {kraDetailsData && kraDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Smart Goal</th>
                            <th>Target</th>
                            <th>Target Achievement Date</th>
                            <th>Attachment</th>
                            <th>Weightage(%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kraDetailsData.map((item: any, idx: any) => {
                            const maxLength = 100;

                            const isLong =
                              item?.category_description?.length > maxLength;
                            const visibleText = showFullText
                              ? item?.category_description
                              : item?.category_description?.slice(
                                  0,
                                  maxLength,
                                ) + (isLong ? "..." : "");

                            return (
                              <tr key={item.id}>
                                <td>{idx + 1}</td>
                                <td>
                                  <p>{item.smart_goals}</p>
                                </td>

                                <td>
                                  <ul>
                                    {JSON.parse(item.target)?.map(
                                      (targetItem: string, index: number) => (
                                        <li key={index}>
                                          {index + 1}.{targetItem}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                </td>

                                <td>{item.target_achievement_date}</td>
                                <td>
                                  {!item.attachment_url ||
                                  item.attachment_url.endsWith("/null") ? (
                                    "N/A"
                                  ) : (
                                    <a
                                      href={item.attachment_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      View
                                    </a>
                                  )}
                                </td>

                                <td>{item.weightage}%</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    {(kraDetailsData &&
                      kraDetailsData.length > 0 &&
                      kraDetailsData[0].status === "E_SUBMIT") ||
                    kraDetailsData[0].status === "M_APPROVED" ? (
                      <>
                        <div className="p-2 d-flex gap-2">
                          <p className="text-danger fw-bold">
                            You have successfully submitted your Performance.
                            Please note that you will not be able to make any
                            further changes.
                          </p>
                        </div>
                      </>
                    ) : null}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Behavioural Competence" ? (
              <>
                {behaDetailsData && behaDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Behavioural Competency</th>
                            <th>Description</th>
                            <th>Weightage(%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {behaDetailsData.map((item: any, idx: any) => {
                            const maxLength = 100;

                            const isLong =
                              item?.category_description?.length > maxLength;
                            const visibleText = showFullText
                              ? item?.category_description
                              : item?.category_description?.slice(
                                  0,
                                  maxLength,
                                ) + (isLong ? "..." : "");

                            return (
                              <tr key={item.id}>
                                <td>{idx + 1}</td>
                                <td>
                                  <p>{item.competency_name}</p>
                                </td>

                                <td>
                                  <ul className="mb-0">
                                    {item.description.map(
                                      (desc: string, idx: number) => (
                                        <li>
                                          {"L" + (idx + 1)}&nbsp;&nbsp;{desc}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                </td>
                                <td>{item?.weightage}%</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    {(behaDetailsData &&
                      behaDetailsData.length > 0 &&
                      behaDetailsData[0].status === "E_SUBMIT") ||
                    behaDetailsData[0].status === "M_APPROVED" ? (
                      <div className="p-2 d-flex gap-2">
                        <p className="text-danger fw-bold">
                          You have successfully submitted your Performance.
                          Please note that you will not be able to make any
                          further changes.
                        </p>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : (
              <>
                {kraDetailsData &&
                kraDetailsData.length > 0 &&
                behaDetailsData &&
                behaDetailsData.length > 0 ? (
                  <>
                    <div className="p-2">
                      <div className="d-flex flex-column gap-4">
                        <div className="d-flex flex-column">
                          <label className="form-label">
                            <strong>Employee Career Aspiration</strong>
                          </label>
                          <textarea
                            name="employee_comments"
                            className="form-control"
                            rows={10}
                            value={
                              comaspiDetailsData?.employee_carrier_aspiration ||
                              ""
                            }
                            readOnly
                          />
                        </div>
                        <div className="d-flex flex-column">
                          <label className="form-label">
                            <strong>Manager Career Aspiration</strong>
                          </label>
                          <textarea
                            name="manager_carrier_aspiration"
                            className="form-control"
                            rows={10}
                            onChange={getInputdata}
                            value={
                              comaspiDetailsData?.manager_carrier_aspiration ||
                              ""
                            }
                            readOnly={
                              comaspiDetailsData?.status === "M_APPROVED"
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {comaspiDetailsData?.status === "M_APPROVED" ? (
                      <div className="p-2 d-flex gap-2">
                        <p className="text-danger fw-bold">
                          You have successfully submitted your Performance.
                          Please note that you will not be able to make any
                          further changes.
                        </p>
                      </div>
                    ) : (
                      <div className="p-2 d-flex justify-content-end gap-2 ">
                        {comaspiDetailsData &&
                          comaspiDetailsData.status !== "M Approved" &&
                          comaspiDetailsData.timingStatus !== "Closed" &&
                          comaspiDetailsData.status !== "Rejected" &&
                          (() => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);

                            const lastDate = new Date(
                              comaspiDetailsData.extended_manager_last_date,
                            );
                            lastDate.setHours(0, 0, 0, 0);

                            return lastDate >= today;
                          })() && (
                            <div>
                              <button
                                className="btn btn-outline-primary"
                                onClick={(e: any) =>
                                  handleSaveOrSubmitComAspi(e, "draft")
                                }
                              >
                                Submit
                              </button>
                            </div>
                          )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            )}
          </section>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <div
        id="behaviouralinfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="behavioural-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="behavioural-modalLabel">
                Behavioural Competency – Rating Scale
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  Behavioural competencies are assessed using a 4-level scale
                  ranging from Low (L1) to Exceeds Expectations (L4).
                </h5>
              </div>

              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Level</th>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Expectation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>L1</td>
                    <td>Low</td>
                    <td>
                      Behaviour does not meet role requirements. Frequently
                      demonstrates gaps in expected competencies.
                    </td>
                    <td>Immediate improvement required</td>
                  </tr>

                  <tr>
                    <td>L2</td>
                    <td>Developing</td>
                    <td>
                      Shows basic understanding of behavioural expectations but
                      applies them inconsistently.
                    </td>
                    <td>Needs regular guidance</td>
                  </tr>

                  <tr>
                    <td>L3</td>
                    <td>Meets Expectations</td>
                    <td>
                      Consistently demonstrates expected behaviours aligned with
                      role requirements.
                    </td>
                    <td>Fully meets role standards</td>
                  </tr>

                  <tr>
                    <td>L4</td>
                    <td>Exceeds Expectations</td>
                    <td>
                      Frequently demonstrates strong behavioural competencies
                      and positively influences others.
                    </td>
                    <td>Above role expectations</td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Behavioural competency ratings focus on how consistently an
                  employee demonstrates expected behaviours such as
                  collaboration, accountability, communication, and leadership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>5</td>
                    <td>Outstanding</td>
                    <td>OS</td>
                    <td>4.01 - 5.00</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Very Good</td>
                    <td>VG</td>
                    <td>3.01 - 4.00</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Good</td>
                    <td>G</td>
                    <td>2.01 - 3.00</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Average</td>
                    <td>Avg</td>
                    <td>1.01 - 2.00</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Poor</td>
                    <td>P</td>
                    <td>0.00 - 1.00</td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Behavioural is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeePerformanceReview;
